import React, { useState, useEffect } from 'react'
import MaterialTable from 'material-table'
import { Grid, Box } from '@material-ui/core'
import CircularProgress from '@mui/material/CircularProgress'
import { getMIPYMERepresentation } from '../../../../services/IFI/get'
import { useAuthentication } from '../../../../context/authenticationContext'

const TableRepresentation = () => {
  const { userIDB2C } = useAuthentication()
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    getRepresentation()
  }, [])

  const getRepresentation = async () => {
    try {
      const response = await getMIPYMERepresentation(userIDB2C)
      if (response.Success) {
        if (response.Data.length > 0) {
          setTableForms(response.Data)
        } else {
          setTableForms([])
        }
      }
    } catch (error) {
      console.log(error)
      setLoading(false)
    }
    setLoading(false)
  }

  const columns = [
    {
      title: 'Identificador',
      field: 'TaxRegistration',
      sorting: true,
      filtering: true,
      // cellStyle: { background: '#009688' },
      // headerStyle: { color: '#fff' },
    },
    {
      title: 'MIPYME',
      field: 'MiPymeName',
      sorting: true,
      filtering: true,
      // cellStyle: { background: '#009688' },
      // headerStyle: { color: '#fff' },
    },
    {
      title: 'Condición MIPYME',
      field: 'MipymeCondition',
      sorting: true,
      filtering: true,
      // cellStyle: { background: '#009688' },
      // headerStyle: { color: '#fff' },
    },
    {
      title: 'Estado MIPYME',
      field: 'MipymeStatus',
      sorting: true,
      filtering: true,
      // cellStyle: { background: '#009688' },
      // headerStyle: { color: '#fff' },
    },

    {
      title: 'Nombre completo',
      field: 'UserName',
      sorting: true,
      filtering: true,
      // cellStyle: { background: '#009688' },
      // headerStyle: { color: '#fff' },
    },
    {
      title: 'Tipo MIPYME',
      field: 'TypeMiPyme',
      sorting: true,
      filtering: true,
      // cellStyle: { background: '#009688' },
      // headerStyle: { color: '#fff' },
    },

    {
      title: 'Correo electrónico ',
      field: 'EMail',
      sorting: true,
      filtering: true,
      // cellStyle: { background: '#009688' },
      // headerStyle: { color: '#fff' },
      align: 'left',
    },
  ]
  // downloadPDF, loadingPDF

  const [TableForms, setTableForms] = useState([])

  // const [openObservation, setOpenObservation] = useState(false)

  return (
    <section>
      {!loading ? (
        <Grid
          container
          style={{
            width: '100%',
            height: 'auto',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <div
            style={{
              height: 'auto',
              width: '96%',
              backgroundColor: '#fff',
              borderRadius: '4px',
            }}
          >
            <div className="App">
              <Grid container spacing={1}>
                <Grid item xs={12} sm={12} md={12}>
                  <MaterialTable
                    columns={columns}
                    data={TableForms}
                    onSelectionChange={(selectedRows) =>
                      console.log(selectedRows)
                    }
                    options={{
                      sorting: true,
                      search: true,
                      searchFieldAlignment: 'right',
                      searchAutoFocus: true,
                      searchFieldVariant: 'standard',
                      filtering: true,
                      paging: true,
                      pageSizeOptions: [2, 5, 10, 20],
                      pageSize: 5,
                      paginationType: 'stepped',
                      showFirstLastPageButtons: false,
                      paginationPosition: 'bottom',
                      exportButton: false,
                      exportAllData: true,
                      exportFileName: 'TableData',
                      // addRowPosition: 'first',
                      actionsColumnIndex: -1,
                      selection: false,
                      showSelectAllCheckbox: false,
                      showTextRowsSelected: false,
                      selectionProps: (rowData) => ({
                        disabled: rowData.age == null,
                        // color:"primary"
                      }),
                      // grouping: true,
                      // columnsButton: true,
                      rowStyle: (data, index) =>
                        index % 2 === 0 ? { background: '#f5f5f5' } : null,
                      headerStyle: { background: '#014b96', color: '#fff' },
                    }}
                    localization={{
                      body: {
                        editRow: {
                          deleteText: '¿Está seguro de eliminar el registro?',
                        },
                        emptyDataSourceMessage: 'No hay registros a desplegar',
                      },
                      header: {
                        actions: 'Acciones',
                      },
                      toolbar: {
                        searchPlaceholder: 'Buscar',
                      },
                    }}
                    title=" "
                  />
                </Grid>
              </Grid>
            </div>
          </div>
        </Grid>
      ) : (
        <Box className="loadingEditContainer">
          <Grid className="loadingSub">
            <CircularProgress />
          </Grid>
        </Box>
      )}
    </section>
  )
}
export default TableRepresentation
